module.exports = __webpack_public_path__ + "static/media/banner.d4f041cf.png";